<template>
  <el-col :span="4" class="left_nav">
    <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
      style="border-right: none;">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>导航一</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1">选项1</el-menu-item>
          <el-menu-item index="1-2">选项2</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="2">
        <i class="el-icon-menu"></i>
        <span slot="title">导航二</span>
      </el-menu-item>
      <el-menu-item index="3">
        <i class="el-icon-document"></i>
        <span slot="title">导航三</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">导航四</span>
      </el-menu-item>
    </el-menu>
  </el-col>
</template>

<script>
export default {
  name: 'nav-list',
  data () {
    return {}
  }
}
</script>

<style lang="less">
.left_nav {
  height: 100%;
  background-color: #ffffff;
  .el-submenu__title {
    text-align: left;
  }
  .el-menu-item {
    text-align: left;
  }
  .el-submenu .el-menu-item {
    text-align: center;
  }
  .el-menu-item .is-active {
    background-color: #ecf5ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu/NavList.vue